import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Do I need to buy expensive equipment?',
  a: 'No. We focus on biological levers like light timing and temperature dumping that cost $0.'
}, {
  q: 'Is this just for Oura users?',
  a: 'It works for any wearable that tracks HRV and Sleep Stages (Whoop, Garmin, Apple Watch, etc.).'
}, {
  q: 'How long does the protocol take?',
  a: 'The morning and evening routines take less than 15 minutes combined.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-brand-dark border-t border-brand-panelBorder" data-id="element-15">
      <div className="max-w-3xl mx-auto px-6" data-id="element-16">
        <h2 className="text-3xl lg:text-4xl font-bold mb-12 text-center" data-id="element-17">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-panel border border-brand-panelBorder rounded-2xl overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-20">
                <span className="font-bold text-lg" data-id="element-21">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-green transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>
              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-24">
                    <div className="px-6 pb-5 text-brand-gray" data-id="element-25">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}